import {Box, Button, Group, Modal, createStyles} from '@mantine/core';
import React from 'react';

import {openScratchFileInNewTab} from './ScratchFileChip';
import {renderFilePreview} from './ScratchFilePaneContent';
import {ScratchFileContent} from './ScratchFileTypes';

interface ScratchFilePreviewModalProps {
  scratchFile: ScratchFileContent;
  opened: boolean;
  onClose: () => void;
}

/** Full-size preview of a scratch file, mounting the preview only while the modal is open. */
export default function ScratchFilePreviewModal({
  scratchFile,
  opened,
  onClose,
}: ScratchFilePreviewModalProps): JSX.Element {
  const {classes} = useStyles();
  const canDownload = scratchFile.externalFileId != null && scratchFile.downloadUrl != null;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={scratchFile.filename}
      closeButtonProps={{'aria-label': 'Close modal'}}
      size="min(1200px, 95vw)"
      centered={true}
      withinPortal={true}
      classNames={{inner: classes.inner, content: classes.content, body: classes.body}}
    >
      <Box className={classes.preview}>{opened && renderFilePreview(scratchFile)}</Box>
      {canDownload && (
        <Group position="right" mt="lg">
          <Button variant="primary" onClick={() => openScratchFileInNewTab(scratchFile)}>
            Download
          </Button>
        </Group>
      )}
    </Modal>
  );
}

const useStyles = createStyles((theme) => ({
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    margin: 'auto',
    maxWidth: '95vw',
  },
  body: {
    paddingTop: theme.spacing.sm,
  },
  preview: {
    position: 'relative',
    boxSizing: 'border-box',
    width: '100%',
    height: 'min(560px, 65vh)',
    minHeight: 320,
    overflow: 'auto',
    borderRadius: theme.radius.md,
    border: `1px solid ${theme.colors.gray[3]}`,
  },
}));
